import React from 'react';
import StripeCheckout from 'react-stripe-checkout';

function computeQuantity(cart) {
    return cart.reduce((count, itemInCart) => count + itemInCart.quantity, 0);
}

class CheckoutWithStripe extends React.Component {
    onToken = (res) => {
        fetch('/save-stripe-token', {
            method: 'POST',
            body: JSON.stringify(),
        }).then(res => {
            res.json().then(data => {
                console.log(`Payment token generated, ${data.name}`)
            })
        })
    };

    render() {
        return (
            <StripeCheckout
                amount = '10.00'
                name="STRIPE_INTEGRATION"
                // functions defined above can be used to add more information while making the API call.
                // description={`Order of ${computeQuantity(cart)} items!`}
                image='https://www.mail-signatures.com/wp-content/uploads/2019/02/How-to-find-direct-link-to-image_Blog-Picture.png'
                stripeKey="pk_test_51JVUXYSCf7lTSgAHlfgJdgUNDVy1n1KVo4gSf8IRnGiz5NPia7TMIeT7gtW1F9jzXZftR7NtkMZfmxBMroW94cbb00YEjI7Kn6"
                currency="INR"
                email='sonumanral@yopmail.com'
                token={this.onToken}/>          
        );
    }
}

export default CheckoutWithStripe